export default class HttpService {

    async _getHeaders() {
        const token = localStorage.getItem("token");
        const headers = {
            "Content-type": "application/json",
            "Access-Control-Allow-Origin": "*",
        };

        if (token) {
            headers["Authorization"] = `Bearer ${token}`;
        }

        return headers;
    }

    async _handleErrors(response) {
        if (response.status === 401 && window.location.pathname !== '/login') {
            localStorage.clear();
            window.location.href = '/login';
            return;
        }

        if (response.ok) return response;

        const erro = await response.json();
        throw new Error(erro.error);
    }

    async get(url) {
        const headers = await this._getHeaders();
        const resposta = await fetch(url, { headers });
        const respostaVerifiada = await this._handleErrors(resposta);
        return respostaVerifiada.json();
    }

    async post(url, dado) {
        const headers = await this._getHeaders();
        const resposta = await fetch(url, {
            headers,
            method: "POST",
            body: JSON.stringify(dado),
        });
        return this._handleErrors(resposta);
    }

    async put(url, dado) {
        const headers = await this._getHeaders();
        const resposta = await fetch(url, {
            headers,
            method: "PUT",
            body: JSON.stringify(dado),
        });
        return this._handleErrors(resposta);
    }

    async delete(url, dado) {
        const headers = await this._getHeaders();
        const resposta = await fetch(url, {
            headers,
            method: "DELETE",
            body: JSON.stringify(dado),
        });
        return this._handleErrors(resposta);
    }
}
